import { BaseResponse } from "domain/payload/response/BaseResponseDto";
import axiosInstance from "../../config/AxiosConfig";
import {
  TimeDepositListResp,
  TimeDepositDetailResp,
} from "domain/payload/response/bankamar/TimeDepositResp";

const TimeDepositStatusService = () => {
  const getList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null,
  ): Promise<TimeDepositListResp> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/amar-integration/time-deposit-status/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page,
            size,
            search,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const getDetail = async (
    token: string,
    id: string
  ): Promise<TimeDepositDetailResp> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/amar-integration/time-deposit-status/detail`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { getList, getDetail };
};

export default TimeDepositStatusService;
